import { HttpService } from '@/services/HttpService';

class Otp {
  subdomain = '/tobacco';
  /**
   * Get academy data
   * data: empty Object
   * @returns {Promise}
   */
  getAcademyData(data) {
    return HttpService.post(`${this.subdomain}/academy`, data);
  }
  /**
   * Get academy detail data
   * data: empty Object
   * @returns {Promise}
   */
  getAcademyDetail(data) {
    return HttpService.post(`${this.subdomain}/academy/detail`, data);
  }
  /**
   * Get academy detail data
   * data: empty Object
   * @returns {Promise}
   */
  getHeaderData(data) {
    return HttpService.post(`${this.subdomain}/academy/header`, data);
  }
  /**
   * Get quiz data
   * @param {number} {Required} contentTypeId
   * @param {number}  priorty //if the request was made for the first question, the priorty parameter should not be added
   * @returns {Promise}
   */
  getQuizData(data) {
    return HttpService.post(`${this.subdomain}/academy/quiz`, data);
  }
  /**
   * Answer quiz
   * @param {number} {Required} surveyId
   * @param {number} {Required} questionId
   * @param {number} {Required} optionId
   * @param {number} {Required} surveyTakenId
   * @returns {Promise}
   */
  answerQuiz(data) {
    return HttpService.post(`${this.subdomain}/academy/quiz/answer`, data);
  }
  /**
   * Finish quiz
   * @param {number} {Required} surveyId
   * @param {number} {Required} surveyTakenId
   * @returns {Promise}
   */
  finishQuiz(data) {
    return HttpService.post(`${this.subdomain}/academy/quiz/finish`, data);
  }
}

export default new Otp();
